<template>
  <div id="userList">
    <lySearch v-model="searchItem.keyword" @search="getUserTree"></lySearch>
    <li
      @click="selectTree(item)"
      v-for="(item, index) in treeData"
      :key="item.id"
    >
      {{ item.name }}
      <Tag v-for="(x, ine) in item.roleNameList" :key="x" color="blue">{{
        x
      }}</Tag>
    </li>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["noFill", "keyword"],
  data() {
    return {
      treeData: [],
      searchItem: {
        keyword: "",
      },
    };
  },
  methods: {
    getUserTree() {
      axios({
        method: "post",
        url: axios.bm + "/user/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        var arr = [];
        for (const i in data) {
          data[i].title = data[i].name;
          arr.push(data[i]);
          /* if (this.noFill==undefined) {
            if (data[i].useState == 0) {
              arr.push(data[i]);
            }
          }else{
            arr.push(data[i]);
          } */
        }
        this.treeData = arr;
      });
    },
    selectTree(y) {
      this.$emit("user", y);
    },
  },
  mounted() {
    this.searchItem.keyword = this.keyword;
    this.getUserTree();
  },
};
</script>
<style>
#userList li {
  padding: 4px 10px;
}
#userList li:hover {
  cursor: pointer;
  background: #dbe8f6;
}
</style>


// WEBPACK FOOTER //
// src/components/common/userTree.vue